module.exports = __webpack_public_path__ + "img/image 2.858b6355.svg";